    <div [class]="'flex rank ' + shape + ' ' + size">
        <div class="img-container">
            <img *ngFor="let starPath of arrayStar" [src]="starPath" />
        </div>
        <span>{{_label}}</span>
    </div>